import styled from "styled-components";
import { colors } from "../../../../styles/colors";

export const ErrorMessageContainer = styled.div`
  color: ${colors.red};
  font-size: 14px;
  margin-top: 10px;
  text-align: center;
  padding: 8px 12px;
  background-color: rgba(255, 45, 85, 0.1);
  border: 1px solid rgba(255, 45, 85, 0.3);
  border-radius: 6px;
`;
